import { useTranslation } from "react-i18next";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const PartialFormDataDialog = ({ open, handleCancel, handleAccept }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>{t("t.partial.data.dialog.title")}</DialogTitle>
      <DialogContent>
        <Alert severity={"warning"}>{t("m.partial.data.dialog.info")}</Alert>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleAccept}>
          {t("l.btn.continue")}
        </Button>
        <Button variant="contained" color={"error"} onClick={handleCancel}>
          {t("l.btn.decline")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default PartialFormDataDialog;
